import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import "./SietovaKalkulacka.css";

function SietovaKalkulacka(props) {

  // keby som potreboval, mam tu aj {props.jazyk}

  const { t, i18n } = useTranslation();

  const [vstupIP, setVstupIP] = useState('10.1.13.35');
  const [vstupPL, setVstupPL] = useState(27);

  const [vysledokWs, setVysledokWs] = useState({});
  const [vysledokWsStav, setVysledokWsStav] = useState("begin");
  const [vysledokRozsah, setVysledokRozsah] = useState("");
  const [vysledokIpciek, setVysledokIpciek] = useState({});

  const [maska, setMaska] = useState("");
  const [zolik, setZolik] = useState("");

  const changeHandlerIP = (event) => {
    if ((event!=null)&&(event.target!=null)) {
        setVstupIP(event.target.value);                
    }
  }

  const changeHandlerPL = (event) => {
    if ((event!=null)&&(event.target!=null)) {
      if ((event.target.value>0)&&(event.target.value<=31)) {
        setVstupPL(event.target.value);                
      }
    }
  }

  const dajVypocitatWebovejSluzbe = () => {
    fetch('https://www.ciscoskolenia.eu/engine/ws/nwcalc/?ip=' + vstupIP + '&pl=' + vstupPL)
    .then(response => response.json())
    .then((data) => {
      setVysledokWsStav(data.status);
      setVysledokWs(data.result);
      setVysledokRozsah(data.result.rozsah.od + " - " + data.result.rozsah.do);
      setVysledokIpciek(data.result.ipciek);
      setMaska(data.result.maska);
      setZolik(data.result.zolik);
    })
  }

  // ked sa zmenia hodnoty vstupIP alebo vstupPL, tak sa vola ws
  useEffect(() => {
    dajVypocitatWebovejSluzbe();
  }, [vstupIP, vstupPL]);

  const btnClickHandler = (event) => {
    dajVypocitatWebovejSluzbe();
  }

  const submitHandler = (event) => {
    event.preventDefault();
  }

  const btnClickPrefixMinusHandler = (event) => {
    if (vstupPL<30) {
      setVstupPL(vstupPL + 1);
    }
  }

  const btnClickPrefixPlusHandler = (event) => {
    if (vstupPL>0) {
      setVstupPL(vstupPL - 1);
    }
  }

  const btnClickTriedaAHandler = (event) => {
    setVstupIP("10.0.0.0");
    setVstupPL(8);
  }

  const btnClickTriedaBHandler = (event) => {
    setVstupIP("172.16.0.0");
    setVstupPL(16);
  }

  const btnClickTriedaCHandler = (event) => {
    setVstupIP("192.168.0.0");
    setVstupPL(24);
  }

  const btnClickTriedaDHandler = (event) => {
    setVstupIP("224.0.0.0");
    setVstupPL(28);
  }

  const btnClickTriedaEHandler = (event) => {
    setVstupIP("240.0.0.0");
    setVstupPL(28);
  }

  const btnSmWcDecHandler = (event) => {
    setMaska(vysledokWs.maska);
    setZolik(vysledokWs.zolik);
  }

  const btnSmWcBinHandler = (event) => {
    setMaska(vysledokWs.maskab);
    setZolik(vysledokWs.zolikb);
  }
  

  return (
    <div className='container'>
      <div className='d-flex shadow row p-4 lit-pasik rounded'>
        <h1 className='mt-2 lit-color-text-h1'>{t('hlNad')}</h1>
        <p>{t('divPop')}</p>
      </div>
      <div className='container'>
      <div className='row'>
          <div className='col-lg-5 '>
            <div className='lit-block pt-5 pb-2 shadow'>
            <div className='mb-4'>
              <p>{t('divPriklPodlTr')}:</p>
              <button className="btn btn-outline-secondary m-1 lit-btn" onClick={btnClickTriedaAHandler}>{t('btnTrA')}</button>
              <button className="btn btn-outline-secondary m-1 lit-btn" onClick={btnClickTriedaBHandler}>{t('btnTrB')}</button>
              <button className="btn btn-outline-secondary m-1 lit-btn" onClick={btnClickTriedaCHandler}>{t('btnTrC')}</button>
              <button className="btn btn-outline-secondary m-1 lit-btn" onClick={btnClickTriedaDHandler}>{t('btnTrD')}</button>
              <button className="btn btn-outline-secondary m-1 lit-btn" onClick={btnClickTriedaEHandler}>{t('btnTrE')}</button>
            </div>
            <p>{t('divRiadCen')}:</p>
            <div class="container d-flex justify-content-center">
              <form onSubmit={submitHandler} className="row g-3 d-flex justify-content-center">
                <div className="col-lg-4">
                  <input type="text" className="form-control" value={vstupIP} onChange={changeHandlerIP} /> 
                </div>
                <div className="col-auto">
                  / 
                </div>
                <div className="col-lg-3">
                  <input type="number" className="form-control" value={vstupPL} onChange={changeHandlerPL} />  
                </div>
                <div className="col-auto">
                  <button type="submit" className="btn btn-primary lit-odoslat-btn" onClick={btnClickHandler}>=</button>
                </div>
              </form>
            </div>
            <div className='d-flex justify-content-center'>
              <div className="progress w-75 striped m-4">
                <div className="progress-bar lit-progress-bar" style={{width: (vstupPL*100/32)+'%'}}>/{vstupPL}</div>
              </div>
            </div>
            <button className="btn btn-outline-secondary btnZnizitPocetHostov" onClick={btnClickPrefixMinusHandler}>- {t('btnDecHosts')}</button>
            <button className="btn btn-outline-secondary btnZvysitPocetHostov" onClick={btnClickPrefixPlusHandler}>+ {t('btnIncHosts')}</button>
        </div>
        </div>
        <div className='col-lg-7 mt-3'>
        { (vysledokWsStav=="failed") && (<div>{vysledokWs.message}</div>)}
          <div>
          <div className='row'>
              <div className='col-lg-6'>
              <h2 className='lit-color-text'>{t('h2VypSM')}</h2>
                <button className="btn btn-outline-secondary m-1 lit-btn" onClick={btnSmWcDecHandler}>{t('btnSmWcDec')}</button>
                <button className="btn btn-outline-secondary m-1 lit-btn" onClick={btnSmWcBinHandler}>{t('btnSmWcBin')}</button>         
              <p className='lit-sc-vysledok'>{t('sm')}: <span>{maska}</span><br />
                {t('wc')}: <span>{zolik}</span>
              </p>
              </div>
              <div className='col-lg-6'>
              <h2 className='lit-color-text'>{t('h2VypocetRozsahovSiete')}</h2>
              <p className='lit-sc-vysledok'>{t('nwid')}: <span>{vysledokWs.nwid}</span><br />
                {t('rozsah')}: <span>{vysledokRozsah}</span><br />
                {t('lbc')}: <span>{vysledokWs.lbc}</span><br />
                {t('gw')}:  <span>{vysledokWs.gw}</span>
              </p>
              </div>
            </div>
            <h2 className='lit-color-text'>{t('h2VypocetMnozstvaIpAdries')}</h2>
            <p className='lit-sc-vysledok'>{t('celkovoIp')}: <span>{vysledokIpciek.celkovo}</span><br />
              {t('pouzitelnychIp')}: <span>{vysledokIpciek.pouzitelnych}</span><br />
              {t('pouzitelnychWoGw')}: <span>{vysledokIpciek.pouzitelnychBezRoutra}</span><br />
              {t('percentIpKolaca')}: <span>{vysledokIpciek.celkovoKolaca} %</span>
              <div className='d-flex justify-content-center p-3'>
                <div className="progress w-75 striped">
                  <div className="progress-bar progress-bar-striped bg-info" style={{width: vysledokIpciek.celkovoKolaca+'%'}}>{vysledokIpciek.celkovoKolaca} %</div>
                </div>
              </div>
            </p>
          </div>
        </div>
      </div>
      </div>
    </div>
  );
}

export default SietovaKalkulacka;
